<div class="menu-items">
    <div class="menu-item"  [ngClass]="{'selected-menu': url === '/portal/office-websites/office-website-account' || url === '/portal/office-websites'}" (click)="selectMenu('office-website-account')">
        Office Website Account<span></span>
    </div> 
       
    <div class="menu-item" (click)="toggleDisplay()">
        Office Information<span></span>
        <span *ngIf="!submenu" class="dropdown-icon pi pi-fw pi-chevron-down"></span>
        <span *ngIf="submenu" class="dropdown-icon pi pi-fw pi-chevron-up"></span>
    </div>
  
    <div class="sub-menu" *ngIf="submenu">
        <div class="menu-item web-display" [ngClass]="{'selected-menu': url === '/portal/office-websites/office-contact-info'}" (click)="selectMenu('office-contact-info')">
            Office Contact Information<span></span>
        </div>     
        
        <div class="menu-item web-display" [ngClass]="{'selected-menu': url === '/portal/office-websites/office-photos'}" (click)="selectMenu('office-photos')">
            Edit Photo<span></span>
        </div> 
     

        <div class="menu-item web-display" [ngClass]="{'selected-menu': url === '/portal/office-websites/office-mls-id'}" (click)="selectMenu('office-mls-id')">
        MLS ID's<span></span>
        </div>
        
        <div class="menu-item web-display" [ngClass]="{'selected-menu': url === '/portal/office-websites/office-bio'}" (click)="selectMenu('office-bio')">
            Office Bio<span></span>
            </div> 
         
        <div class="menu-item web-display" [ngClass]="{'selected-menu': url === '/portal/office-websites/office-designations'}" (click)="selectMenu('office-designations')">
            Designations<span></span>
        </div>   
        <div class="menu-item web-display" [ngClass]="{'selected-menu': url === '/portal/office-websites/office-specilaties'}" (click)="selectMenu('office-specilaties')">
            Specialties<span></span>
        </div>   
        <div class="menu-item web-display" [ngClass]="{'selected-menu': url === '/portal/office-websites/office-languages'}" (click)="selectMenu('office-languages')">
            Languages Spoken<span></span>
        </div>  
        <!-- <div class="menu-item web-display" [ngClass]="{'selected-menu': url === '/portal/office-websites/office-cities-counties'}" (click)="selectMenu('office-cities-counties')">
            Counties and Cities Served<span></span>
        </div> -->
        <div class="menu-item web-display" [ngClass]="{'selected-menu': url === '/portal/office-websites/office-social-network-affiliations'}" (click)="selectMenu('office-social-network-affiliations')">
            Social Network Affiliations<span></span>
        </div>

        <!-- <div class="menu-item web-display" [ngClass]="{'selected-menu': url === '/portal/office-websites/office-videos'}" (click)="selectMenu('office-videos')">
            Add/Edit Office Video<span></span>
        </div> -->
    </div>

    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/office-websites/office-website-listings'}" (click)="selectMenu('office-website-listings')">
        Office Website & Listings<span></span>
    </div>

    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/office-websites/cooperative-compensation'}" (click)="selectMenu('cooperative-compensation')" *ngIf="enableCoopCompSubMenu">
        Cooperative Compensation<span></span>
    </div>

</div>
<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onConfirm)="selectMenuConfirmation()"
  #changeMenuModal>
</app-search-update-confirmation>